import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateJobNoteRequestBody = ApiRequestBody<
  typeof endpoints.jobNotes,
  'post'
>;
type CreateJobNoteParams = {
  jobId: string;
  body: CreateJobNoteRequestBody;
};

export const useCreateJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, body }: CreateJobNoteParams) => {
      const { data } = await fetchClient.POST(endpoints.jobNotes, {
        params: { path: { id: jobId } },
        body,
      });

      return data;
    },
    onSettled: (_data, _error, { jobId }) => {
      invalidateQuery(jobsQueryKeys.notes(jobId))();
    },
  });
};
